import { createContext, useContext, useState } from "react";

const MaintenanceContext = createContext();

export const MaintenanceProvider = ({ children }) => {
    const [maintenance, setMaintenance] = useState(false);

    return (
        <MaintenanceContext.Provider value={{ maintenance, setMaintenance }}>
            {children}
        </MaintenanceContext.Provider>
    );
};

export const useMaintenance = () => useContext(MaintenanceContext);
